/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================
​
* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
​
Coded by www.creative-tim.com
​
 =========================================================
​
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 PRO React components
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
import CountUp from "react-countup";
import CircularProgress from "@mui/material/CircularProgress";
import colors from "../../assets/theme/base/colors";

import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";

function StatisticsCard({ color, title, count, subtitle, icon, loading }) {
  return (
    <Card pt={1}>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {/* <Icon fontSize="medium" color="inherit"> */}
          {icon}
          {/* </Icon> */}
        </MDBox>
        <MDBox textAlign="right" ml={3} lineHeight={1.25}>
          <MDTypography variant="button" fontWeight="bold" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">
            {/* {count} */}
            {loading ? (
              <CircularProgress color="info" size={30} />
            ) : (
              <CountUp end={count} duration={1} />
            )}
          </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={1} px={1} pl={2}>
        <MDTypography
          component="p"
          variant="button"
          color="text"
          display="flex"
        >
          <MDTypography component="span" variant="button" fontWeight="bold">
            {loading ? "" : ""}
          </MDTypography>
          <strong> {subtitle}</strong>
        </MDTypography>
        {subtitle == "" ? (
          <MDBox pb={2.5} sx={{ display: { xs: "none", md: "flex" } }} />
        ) : (
          <></>
        )}
      </MDBox>
    </Card>
  );
}
// Setting default values for the props of ComplexStatisticsCard
StatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
  loading: true,
  subtitle: "",
};

// Typechecking props for the ComplexStatisticsCard
StatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default StatisticsCard;
